import { StateNode, TLStateNodeConstructor } from "tldraw"
import { EraserErasing } from "./EraserErasing"
import { EraserIdle } from "./EraserIdle"

export class EraserTool extends StateNode {
  static override id = "eraser2"
  static override initial = "eraser-idle"
  static override children(): TLStateNodeConstructor[] {
    return [EraserIdle, EraserErasing]
  }

  override shapeType = "marker-shape"
}
